import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const DEFAULT_API_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";
const DEFAULT_DISPLAY_FORMAT = "DD MMM YYYY, hh:mm A";

const DateUtils = {
  /**
   * Convert Local Date → UTC (for API payload)
   * @param {Date | string} date
   * @param {string} format
   * @returns {string|null}
   */
  toUTC(date) {
    if (!date) return null;
    return dayjs(date).utc().toISOString();
  },

  /**
   * Convert UTC → Local Time (for UI display)
   * @param {string} utcDate
   * @param {string} format
   * @returns {string}
   */
  fromUTC(utcDate, format = DEFAULT_DISPLAY_FORMAT) {
    if (!utcDate) return "";
    return dayjs.utc(utcDate).local().format(format);
  },

  /**
   * Get user's timezone
   * @returns {string}
   */
  getUserTimezone() {
    return dayjs.tz.guess();
  },

  /**
   * Convert UTC → specific timezone (optional advanced use)
   * @param {string} utcDate
   * @param {string} timezone
   * @param {string} format
   */
  fromUTCToTimezone(
    utcDate,
    timezone = dayjs.tz.guess(),
    format = DEFAULT_DISPLAY_FORMAT,
  ) {
    if (!utcDate) return "";
    return dayjs.utc(utcDate).tz(timezone).format(format);
  },

  /**
   * Convert any date → formatted local date
   */
  formatLocal(date, format = DEFAULT_DISPLAY_FORMAT) {
    if (!date) return "";
    return dayjs(date).format(format);
  },
};

export default DateUtils;
